



































import { Vue, Component, PropSync, Watch, Prop } from 'vue-property-decorator';
import EFunnel from './e-funnel.vue';
import ELine from './e-line.vue';
import ETreemap from './e-treemap.vue';
import EColumns from './e-columns.vue';
import IndicatorServices from '@/services/indicator';
import { getRange } from '@/libs/time';
import { IndicatorInfo } from '@/services/analyzeCustom';
import PreviewChart from './preview-chart.vue';

@Component({
  components: { EFunnel, ELine, EColumns, ETreemap, PreviewChart }
})
export default class AddCustomInd extends Vue {
  @PropSync('indicatorInfo') syncIndicatorInfo!: IndicatorInfo;
  @Prop() formData!: any;

  indSrv = new IndicatorServices();
  date: string[] = getRange('week');
  visible: boolean = false;
  indTree: any[] = [];
  selectedData: any[] = [];
  type = 0;

  created() {
    this.getIndTree();
    this.onDateChange();
  }

  @Watch('syncIndicatorInfo')
  onSyncIndicatorInfoChange() {
    // if (this.dataSource.length === 0) {
    //   setTimeout(() => this.onSyncIndicatorInfoChange(), 100);
    //   return false;
    // }
    // let targetKeys = this.syncIndicatorInfo.indicatorInfoList.map((v: any) => v.indCode);
    // this.onTargetKeysChange(targetKeys);
  }

  @Watch('date')
  onDateChange() {
    let [startTime, endTime] = this.date;
    this.syncIndicatorInfo.startTime = startTime;
    this.syncIndicatorInfo.endTime = endTime;
  }

  async getIndTree() {
    let list = await this.indSrv.getTree({ status_eq: 0, approveStatus_ge: 4, approveStatus_le: 5 });
    this.indTree = list.map((v: any) => this.packIndTree(v));
  }

  packIndTree(item: any) {
    return {
      ...item,
      key: item.indCode,
      title: item.indName,
      children: (item.children || []).map((ind: any) => this.packIndTree(ind))
    };
  }

  onSelected(selectedKeys: any, e: any) {
    // console.log(selectedKeys, e);
    let ind = e.node.dataRef;
    if (!this.selectedData.find(v => v.key === ind.key)) {
      this.selectedData.push({ ...ind, children: [] });
    }
  }

  onDrop(e: any) {
    const dropKey = e.node.eventKey;
    const dragKey = e.dragNode.eventKey;
    const dropPos = e.node.pos.split('-');
    const dropPosition = e.dropPosition - Number(dropPos[dropPos.length - 1]);
    let list = this.selectedData;
    let dropIndex = list.findIndex(v => v.key === dropKey);
    let index = list.findIndex(v => v.key === dragKey);
    if (index > dropIndex) {
      if (dropPosition === 1) {
        list.splice(dropIndex + 1, 0, list[index]);
      } else {
        list.splice(dropIndex, 0, list[index]);
      }
      list.splice(index + 1, 1);
    } else {
      if (dropPosition === -1) {
        list.splice(dropIndex, 0, list[index]);
      } else {
        list.splice(dropIndex + 1, 0, list[index]);
      }
      list.splice(index, 1);
    }
  }

  dragedKey: string = '';
  onDragstart(e: any) {
    this.dragedKey = e.node.eventKey;
  }

  onDragend(e: any) {
    console.log('end');
    this.dragedKey = '';
  }

  onDelete() {
    let key = this.dragedKey;
    let idx = this.selectedData.findIndex(v => v.key === key);
    this.selectedData.splice(idx, 1);
  }

  allowDrop(e: any) {
    e.preventDefault();
  }

  @Watch('selectedData')
  onSelectedDataChange() {
    this.syncIndicatorInfo.indicatorInfoList = this.selectedData;
  }

  preview() {
    if ((this.syncIndicatorInfo.indicatorInfoList || []).length === 0) {
      this.$message.error('需要选定指标');
      return false;
    }
    this.visible = true;
  }
}
